export default __webpack_public_path__ + "static/media/pickup-assigned-icon.ebbe54dd.svg";